<template>
  <div class="tradingPlatform-page">
    <el-tabs v-model="goodsTypeTab" @tab-click="goodsTypeTabHandleClick">
      <el-tab-pane label="当期网络零售额" name="currentSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="transactionForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span
                  :class="transactionTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                  @click="oneMonth('transaction')" v-if="transactionForm.resource == '1'">近1个月</span>
                <span
                  :class="transactionTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                  @click="twelveMonth('transaction')" v-if="transactionForm.resource == '2'">近13个月</span>
                <span
                  :class="transactionTime=='2'?'cursor-pointer text-1E88E5 text-content':' cursor-pointer text-content'"
                  @click="transactionTime = 2">月度</span>
              </el-col>
              <el-col :span="4" v-if="transactionForm.resource == '2'">
                <el-date-picker v-model="transactionForm.startTime" type="month" @change="getTransactionList(transactionTime = 2)"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1" v-if="transactionForm.resource == '2'">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="transactionForm.endTime" type="month" v-if="transactionForm.resource == '2'"
                                @change="getTransactionList(transactionTime = 2)"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
                <el-date-picker v-model="transactionForm.endTime" v-if="transactionForm.resource == '1'" type="month"
                                @change="getTransactionList(transactionTime = 2)"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>

              </el-col>
            </el-form-item>
            <el-form-item label="平台：">
              <el-radio-group v-model="transactionForm.resource" class="margin-r-20" @change="tranResource()">
                <el-radio label="1">全平台</el-radio>
                <el-radio label="2">单平台</el-radio>
              </el-radio-group>
              <el-select v-model="transactionForm.platform" placeholder="请选择" size="small"
                         :disabled="transactionForm.resource=='1'" @change="getTransactionList()">
                <el-option v-for="platform in platformList" :label=platform.platform :value=platform.platform :key="platform.id"
                           class=""></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-card>
        <el-row v-if="transactionForm.resource == '1'" class="margin-l-30  margin-t-20 margin-r-30">
          <el-col :span="12">
            <el-card>
              <chart ref="chart1" :options="transactionPie" autoresize class="width-z100"></chart>
            </el-card>

          </el-col>
          <el-col :span="12" class="padding-l-20">
            <el-card>
              <el-table :data="transactionTable" stripe height="400" class="border-DEDEDE">
                <el-table-column prop="ext" label="排名" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="交易平台" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_pro" label="占比（%）" align="center"></el-table-column>
              </el-table>
            </el-card>

          </el-col>
        </el-row>
        <el-row v-if="transactionForm.resource == '2'" class="margin-l-30 margin-r-30 margin-t-20">
          <el-col :span="13">
            <el-card>
              <chart ref="chart1" :options="transactionPie" autoresize class="width-z100"></chart>
            </el-card>
          </el-col>
          <el-col :span="11" class="padding-l-20">
            <el-card>
            <el-table :data="singleTransactionTable" stripe height="400" class="border-DEDEDE">
              <el-table-column prop="times" label="时间" align="center"></el-table-column>
              <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
              <el-table-column prop="absoulte_value_pro" label="占比（%）" align="center"></el-table-column>
            </el-table>
            </el-card>
          </el-col>
        </el-row>

      </el-tab-pane>
      <el-tab-pane label="累计网络零售额" name="cumulativeSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="transactionForm" label-width="92px">
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span
                  :class="transactionTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                  @click="oneMonth('transaction')" v-if="transactionForm.resource == '1'">近1个月</span>
                <span
                  :class="transactionTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                  @click="twelveMonth('transaction')" v-if="transactionForm.resource == '2'">近13个月</span>
                <span
                  :class="transactionTime=='2'?'cursor-pointer text-1E88E5 text-content':' cursor-pointer text-content'"
                  @click="transactionTime = 2">月度</span>
              </el-col>
              <el-col :span="4" v-if="transactionForm.resource == '2'">
                <el-date-picker v-model="transactionForm.startTime" type="month" @change="getTransactionList(transactionTime = 2)"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1" v-if="transactionForm.resource == '2'">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="transactionForm.endTime" type="month" v-if="transactionForm.resource == '2'"
                                @change="getTransactionList(transactionTime = 2)" :picker-options="pickerOptions"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
                <el-date-picker v-model="transactionForm.endTime" v-if="transactionForm.resource == '1'" type="month"
                                @change="getTransactionList(transactionTime = 2)" :picker-options="pickerOptions"
                                placeholder="选择日期" class="width-z100" size="small" format="yyyy-MM"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>

              </el-col>
            </el-form-item>
            <el-form-item label="平台：">
              <el-radio-group v-model="transactionForm.resource" class="margin-r-20" @change="tranResource()">
                <el-radio label="1">全平台</el-radio>
                <el-radio label="2">单平台</el-radio>
              </el-radio-group>
              <el-select v-model="transactionForm.platform" placeholder="请选择" size="small"
                         :disabled="transactionForm.resource=='1'" @change="getTransactionList()">
                <el-option v-for="platform in platformList" :label=platform.platform :value=platform.platform :key="platform.id"
                           class=""></el-option>
              </el-select>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getTransactionList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-row v-if="transactionForm.resource == '1'" class="margin-l-30  margin-t-20 margin-r-30">
          <el-col :span="12">
            <el-card>
              <chart ref="chart1" :options="transactionPie" autoresize class="width-z100"></chart>
            </el-card>

          </el-col>
          <el-col :span="12" class="padding-l-20">
            <el-card>
              <el-table :data="transactionTable" stripe height="400" class="border-DEDEDE">
                <el-table-column prop="ext" label="排名" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="交易平台" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_pro" label="占比（%）" align="center"></el-table-column>
              </el-table>
            </el-card>

          </el-col>
        </el-row>
        <el-row v-if="transactionForm.resource == '2'" class="margin-l-30 margin-r-30 margin-t-20">
          <el-col :span="13">
            <el-card>
              <chart ref="chart1" :options="transactionPie" autoresize class="width-z100"></chart>
            </el-card>
          </el-col>
          <el-col :span="11" class="padding-l-20">
            <el-card>
              <el-table :data="singleTransactionTable" stripe height="400" class="border-DEDEDE">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_pro" label="占比（%）" align="center"></el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    name: 'tradingPlatform',
    data () {
      return {
        goodsTypeTab: 'currentSales',
        chooseType: '当期网络零售额',//当前选择查询条件
        transactionForm: {resource: '1', startTime: '', endTime: '', platform: '全平台'},//交易平台筛选条件
        transactionPie: {}, //平台图表
        transactionTable: [],
        singleTransactionTable: [],//单平台表格
        platformList: [],

        transactionTime: '1',
        transactionTitle: '',

        regionDis: true,
        //表格数据
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.twelveMonth()
      this.oneMonth()
      this.getPlatform()
      // this.oneMonth()
    },
    methods: {
      goodsTypeTabHandleClick (tab, event) {
        if (tab.name == 'cumulativeSales') {
          this.chooseType = '累计网络零售额'
          this.getTransactionList()
        }
        if (tab.name == 'currentSales') {
          this.chooseType = '当期网络零售额'
          this.getTransactionList()
        }

      },
      //交易平台
      getTransactionList () {
        this.$http.get(this.header + '/qyjc/cannal', {
          params: {
            index_type: this.chooseType,
            sMonth: this.transactionForm.startTime,
            eMonth: this.transactionForm.endTime,
            platform: this.transactionForm.platform
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.transactionTable = []
            let platform = res.data.list
            if (this.transactionForm.resource == '1') {
              let transactionList = {name: [], transactionData: []}
              res.data.list.forEach((y, index) => {
                if(y.absoulte_key != '其它' &&  y.absoulte_value){
                  this.transactionTable.push(y)
                }
                if(y.absoulte_value || y.absoulte_key == '其它'){
                  transactionList.name.push(y.absoulte_key)
                  let transactionBar = {
                    name: y.absoulte_key,
                    value: y.absoulte_value_pro
                  }
                  transactionList.transactionData.push(transactionBar)
                }

                // return label
              })

              this.transactionPie = {
                title: {//图表标题
                  text: '各交易平台' + this.transactionTitle + '占比',
                  left: 'center',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300,
                    marginBottom: 1000
                  },
                },
                tooltip: {
                  trigger: 'item',
                  formatter: '{b}: {d}%'
                },
                legend: {
                  orient: 'horizontal',
                  y: 'bottom',
                  data: transactionList.name
                },
                series: [
                  {
                    name: '访问来源',
                    type: 'pie',
                    radius: ['45%', '60%'],
                    center: ['50%', '40%'],
                    avoidLabelOverlap: false,
                    label: {
                      normal: {
                        show: false,
                        position: 'center'
                      },
                      emphasis: {
                        show: true,
                        textStyle: {
                          fontSize: '30',
                          fontWeight: 'bold'
                        }
                      }
                    },
                    labelLine: {
                      normal: {
                        show: false
                      }
                    },
                    itemStyle: {
                      normal: {
                        color: function (params) {
                          let colorList = ['#8589e2','#60D6CA', '#3fd6a3', '#F7AE4E', '#85B0FB', '#FFC4C6', '#4C8DFF', '#FF9F7F', '#FFDB5C', '#67E0E3', '#9FE6B8', ]
                          //  var colorList = ['red','blue'];
                          return colorList[params.dataIndex % 11]
                        }
                      },

                    },
                    data: transactionList.transactionData
                  }
                ]
              }
            } else {
              let data = []
              let compare = []
              let time = []
              res.data.list.forEach((y, index) => {
                time.push(y.month)
                let yMoney = {
                  value: y.absoulte_value,
                  unit: '万元'
                }
                let xSimple = {
                  value: y.absoulte_value_pro,
                  unit: '%'
                }
                compare.push(xSimple)
                data.push(yMoney)
              })
              this.singleTransactionTable = res.data.list.reverse()
              this.transactionPie = {
                title: {//图表标题
                  text: this.transactionForm.platform + this.transactionTitle + '变化趋势',
                  left: 'center',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300,
                    marginBottom: 1000
                  },
                },
                legend: {//图表说明  horizontal竖着显示vertical横显示
                  orient: 'horizontal',
                  y: 'bottom',
                  // x: 'left',
                  data: ['零售额', '占比']
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: function (e) {
                    return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  }
                },
                xAxis: {
                  type: 'category',
                  data: time
                },
                yAxis: [{
                  type: 'value',
                  name: '万元',
                }, {
                  type: 'value',
                  name: '%',
                  splitLine:{//去除网格线
                    show:false
                  },
                  // min: 0,
                  // max: 35,
                  // interval: 5,
                  axisLabel: {
                    formatter: '{value} %'
                  }
                }],
                series: [{
                  name: '零售额',
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {
                    normal: {
                      color: '#7888ed'
                    },
                    emphasis: {
                      color: '#83bff6'
                    }
                  },
                  data: data,
                }, {
                  name: '占比',
                  type: 'line',
                  yAxisIndex: 1,
                  itemStyle: {
                    normal: {
                      color: '#FB975B'
                    }
                  },
                  data: compare
                }]
              }
            }

          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取交易平台列表
      getPlatform () {
        this.$http.get(this.header + '/qyjc/getPlatform').then(res => {
          if (res.data.code == 0) {
            this.platformList = res.data.platform
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      tranResource () {
        if (this.transactionForm.resource == '1') {
          this.transactionForm.platform = '全平台'
          this.transactionForm.startTime = ''
          this.getTransactionList()
        } else {
          this.transactionForm.platform = '京东商城'
          this.twelveMonth('transaction')
          // this.getTransactionList()
        }
      },
      //选择近13个月
      twelveMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        this.wholeTime = '1'
        if (day > 14) {
          this.transactionForm.startTime = dataArr[13]
          this.transactionForm.endTime = dataArr[1]
        } else {
          this.transactionForm.startTime = dataArr[14]
          this.transactionForm.endTime = dataArr[2]
        }
        this.getTransactionList()

      },
      //选择近1个月
      oneMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (day > 14) {
          this.transactionForm.endTime = dataArr[1]
        } else {
          this.transactionForm.endTime = dataArr[2]
        }
        this.transactionTime = '1'
        this.getTransactionList()
      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxInt = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxVal = maxInt * 10//让显示的刻度是整数
        return maxVal
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minInt = Math.floor(min / 10)
        let minVal = minInt * 10//让显示的刻度是整数
        return minVal
      },

      //选择近1个月
      // oneMonth (val) {
      //   var dataArr = []
      //   var data = new Date()
      //   var year = data.getFullYear()
      //   data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
      //   for (var i = 0; i < 3; i++) {
      //     data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
      //     var m = data.getMonth() + 1
      //     m = m < 10 ? '0' + m : m
      //     dataArr.push(data.getFullYear() + '-' + (m))
      //   }
      //   if (val == 'city') {
      //     this.wholeTime = '1'
      //     // this.cityForm.startTime = dataArr[1]
      //     this.cityForm.endTime = dataArr[2]
      //     this.getCityList()
      //   } else if (val == 'product') {
      //     this.productTime = '1'
      //     // this.productForm.startTime = dataArr[1]
      //     this.productForm.endTime = dataArr[2]
      //     this.getProductList()
      //   } else if (val == 'transaction') {
      //     this.transactionTime = '1'
      //     // this.transactionForm.startTime = dataArr[1]
      //     this.transactionForm.endTime = dataArr[2]
      //     this.getTransactionList()
      //   } else {
      //     this.wholeTime = '1'
      //     this.cityForm.endTime = dataArr[2]
      //     this.productTime = '1'
      //     // this.productForm.startTime = dataArr[1]
      //     this.productForm.endTime = dataArr[2]
      //     this.transactionTime = '1'
      //     // this.transactionForm.startTime = dataArr[1]
      //     this.transactionForm.endTime = dataArr[2]
      //     this.getCityList()
      //     this.getTransactionList()
      //     this.getProductList()
      //   }
      //   console.dir(this.cityForm)
      // },
    }
  }
</script>

<style>

  .tradingPlatform-page {}

  .tradingPlatform-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .tradingPlatform-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .tradingPlatform-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .tradingPlatform-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .tradingPlatform-page .el-form-item {
    margin-bottom: 0;
  }

  .tradingPlatform-page .el-radio, .tradingPlatform-page .el-form-item__label {
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/area/tradingPlatform.vue